import React, { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../Signup/signup.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import NavBarAuth from "../../../../components/navbar/navbarAuth";
import axios from "axios";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import countryList from "react-select-country-list";

function ProfileCreation() {
  const { id } = useParams();
  const navigate = useNavigate();

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("Pakistan");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [CountryList, setCountryList] = useState([]);

  // Add validation states
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    phone: "",
    streetAddress: "",
    city: "",
    country: "",
    state: "",
    zipCode: "",
  });

  // Validation functions
  const validateName = (name) => {
    return /^[a-zA-Z\s]{2,30}$/.test(name);
  };

  const validatePhone = (phoneNumber) => {
    return phoneNumber.length >= 10;
  };

  const validateZipCode = (zip) => {
    return /^\d{4,10}$/.test(zip);
  };

  const validateDOB = (date) => {
    const today = new Date();
    const birthDate = new Date(date);
    const age = today.getFullYear() - birthDate.getFullYear();
    return age >= 18;
  };

  const validateForm = () => {
    const newErrors = {};

    // First Name validation
    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Last Name validation
    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // DOB validation
    if (!dob) {
      newErrors.dob = "Date of birth is required";
    }

    // Phone validation
    if (!phone || phone.length < 10) {
      newErrors.phone = "Valid phone number is required";
    }

    // Address validation
    if (!streetAddress.trim()) {
      newErrors.streetAddress = "Street address is required";
    }

    // City validation
    if (!city.trim()) {
      newErrors.city = "City is required";
    }

    // Country validation
    if (!country) {
      newErrors.country = "Country is required";
    }

    // State validation
    if (!state.trim()) {
      newErrors.state = "State is required";
    }

    // Zip code validation
    if (!zipCode) {
      newErrors.zipCode = "Zip code is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      showAlert("Please fill all fields", "danger");
      return;
    }

    try {
      setIsLoading(true);
      const profileData = {
        FirstName: firstName,
        LastName: lastName,
        DOB: dob,
        Phone: phone,
        Homeaddress: {
          Address: streetAddress,
          City: city,
          Country: country,
          State: state,
          Zip: zipCode,
        },
      };

      const response = await axios.put(
        `${BaseURL}/api/auth/createProfile/${id}`,
        profileData
      );

      if (response.data.success) {
        navigate(`/industry/${id}`);
      } else {
        showAlert(response.data.message || "Error creating profile", "danger");
        setIsLoading(false);
      }
    } catch (error) {
      showAlert(error.message || "Error creating profile", "danger");
      setIsLoading(false);
    }
  };

  const fetchCountry = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/getcountry`);
      const data = await response.json();
      setCountryList(data.Country);
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  return (
    <>
      <NavBarAuth />
      <div className="bg-gray-100">
        <div className="w-[50%] h-2 bg-primarygreen rounded-r-full"></div>
      </div>
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-pop font-bold mb-4">Create profile</h2>
          <p className="text-gray-600 font-pop mb-6 max-w-sm">
            Personal information
          </p>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  setErrors((prev) => ({ ...prev, firstName: "" }));
                }}
                className={`w-full px-6 border-2 ${
                  errors.firstName ? "border-red-500" : "border-transparent"
                } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              />
              {errors.firstName && (
                <p className="text-red-500 text-sm mt-1 ml-4">
                  {errors.firstName}
                </p>
              )}
            </div>

            <div className="mb-4">
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  setErrors((prev) => ({ ...prev, lastName: "" }));
                }}
                className={`w-full px-6 border-2 ${
                  errors.lastName ? "border-red-500" : "border-transparent"
                } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              />
              {errors.lastName && (
                <p className="text-red-500 text-sm mt-1 ml-4">
                  {errors.lastName}
                </p>
              )}
            </div>

            <div className="mb-4">
              <input
                type="date"
                id="dob"
                name="dob"
                placeholder="Date of Birth"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              />
            </div>

            <div className="w-[100%] h-[2px] bg-gray-200"></div>

            <p className="text-gray-600 font-pop mb-4 max-w-sm mt-4">
              Home address
            </p>
            <div className="mb-4">
              <input
                type="text"
                id="street-address"
                name="street-address"
                placeholder="Street address"
                value={streetAddress}
                onChange={(e) => setStreetAddress(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              />
            </div>

            <div className="mb-4">
              <input
                type="text"
                id="city"
                name="city"
                placeholder="City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              />
            </div>

            <div className="mb-4">
              <select
                name="country"
                id="country"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              >
                <option value="">Select Country</option>
                {CountryList.map((item, index) => (
                  <option value={item}>{item}</option>
                ))}
              </select>
            </div>

            <div className="mb-4 flex justify-between gap-2">
              <input
                name="state"
                id="state"
                value={state}
                placeholder="State"
                onChange={(e) => setState(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              />
              <input
                type="number"
                id="zip-code"
                name="zip-code"
                placeholder="Zip Code"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                className="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full  bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none"
              />
            </div>

            <div className="w-[100%] h-[2px] bg-gray-200"></div>

            <p className="text-gray-600 font-pop mb-4 max-w-sm mt-4">
              Contact information
            </p>

            <div className="mb-4">
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  setErrors((prev) => ({ ...prev, phone: "" }));
                }}
                containerClass={`rounded-full ${
                  errors.phone ? "border-2 border-red-500" : ""
                }`}
                inputClass={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-green-500 focus:outline-none`}
                buttonStyle={{
                  borderTopLeftRadius: "9999px",
                  borderBottomLeftRadius: "9999px",
                }}
                inputStyle={{
                  width: "100%",
                  borderRadius: "9999px",
                }}
                required
              />
              {errors.phone && (
                <p className="text-red-500 text-sm mt-1 ml-4">{errors.phone}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`${
                isLoading ? "opacity-50 cursor-not-allowed" : ""
              } my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                </div>
              ) : (
                "Next"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ProfileCreation;
